export default {
    setCurrentUser: (state, newValue) =>  {state.currentUser = newValue;},
    setLanguage: (state, newValue) =>  {state.language = newValue;},
    setSidebarwidth: (state, newValue) =>  {state.sidebarwidth = newValue;},
    setMenu: (state, newValue) =>  {state.menu = newValue;},
    setLastMenuItemOpen: (state, newValue) =>  {state.lastMenuItemOpen = newValue;},
};